import { getInstance } from '@module-federation/enhanced/runtime';
function LinkPlugin() {
  return {
    name: 'link-plugin',
    createLink({
      url
    }) {
      const link = document.createElement('link');
      link.setAttribute('href', url);
      link.setAttribute('rel', 'preload');
      link.setAttribute('as', 'script');
      link.setAttribute('crossorigin', 'anonymous');
      return link;
    }
  };
}
let isSetup = false;
export function setup() {
  if (isSetup) return;
  const instance = getInstance();
  instance === null || instance === void 0 || instance.registerPlugins([LinkPlugin()]);
  isSetup = true;
}